<template>
  <div>
    <v-container fluid class="px-5">
      <v-btn text @click="previousPage()" >
        <v-icon small color="red" >mdi-arrow-left</v-icon>
        <label class="mx-2 px-2 text--disabled" style="letter-spacing: 0.6px;">Voltar</label>
      </v-btn>
      <label class="ml-4 text--disabled" style="letter-spacing: 0.6px;">{{path}}</label>
      <v-row class="py-5">
        <AccessPermissionDetail :title="backOfficeRules" :user-role-creation="userRoleBackOffice" :user-role-apply="userRoleBackOffice"  :screenType="typeAccessPermission" :path="path" visualize-permission="alcada_drive_visualizar_regras_backoffice" modify-permission="alcada_drive_modificar_regras_backoffice" :allowed-type-rules="typeRulesB2B" />
        <AccessPermissionDetail :title="generalRulesBackOffice" :user-role-creation="userRoleBackOffice" visualize-permission="alcada_drive_visualizar_regras_gerais_backoffice" :screenType="typeFirewall" :path="path" />
        <AccessPermissionDetail :title="companyRules" :user-role-creation="userRoleBackOffice" :user-role-apply="userRoleCompany"  :screenType="typeAccessPermission" :path="path" visualize-permission="alcada_drive_visualizar_regras_empresa" modify-permission="alcada_drive_modificar_regras_empresa" />
        <AccessPermissionDetail :title="masterRules" :user-role-creation="userRoleCompany" :user-role-apply="userRoleCompany"  :screenType="typeAccessPermission" :path="path" visualize-permission="alcada_drive_visualizar_regras_usuario_master" modify-permission="alcada_drive_modificar_regras_usuario_master" :allowed-type-rules="typeRulesC2C" />
        <AccessPermissionDetail :title="generalRulesCompany" :user-role-creation="userRoleCompany" visualize-permission="alcada_drive_visualizar_regras_gerais_empresa" :screenType="typeFirewall" :path="path" />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AccessPermissionDetail from './AccessPermissionDetail.vue';

export default {
  name: 'ShowAccessPermission',
  components: {
    AccessPermissionDetail,
  },
  data: () => ({
    backOfficeRules: 'Regras Backoffice',
    companyRules: 'Regras Empresa - Criadas pela Corretora',
    generalRulesBackOffice: 'Regras Gerais Backoffice',
    generalRulesCompany: 'Regras Gerais Empresa',
    masterRules: 'Regras Empresa - Criadas pelo Usuário Master',
    userRoleBackOffice: 'BACKOFFICE',
    userRoleCompany: 'COMPANY',
    typeFirewall: 'FIREWALL',
    typeAccessPermission: 'ACCESS_PERMISSION',
    path: '',
    token: '',
    typeRulesB2B: ['GLOBAL', 'PROFILE', 'USER'],
    typeRulesC2C: ['USER'],
  }),
  props: {
    item: {
      type: Object,
      required: false,
    },
    indexesHistoryProps: {
      type: Array,
      required: false,
    },
  },
  methods: {
    previousPage() {
      const actualPathArray = this.path.split('/');
      let upperPath = '';
      if (actualPathArray.length > 1) {
        actualPathArray.pop();
        upperPath = actualPathArray.join('/');
      }
      this.$router.push({ name: 'access-permission', params: { path: upperPath, indexesHistoryProps: this.indexesHistoryProps }, query: { token: this.token } });
    },
  },
  created() {
    this.path = this.item.path;
    this.token = this.$route.query.token;
  },
};
</script>
